import React, { useState, useEffect } from 'react';
import { MdPrint } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from 'react-icons/fa';
import { Container, Info, Loader, Table, Tbody, Pagination } from './styles';
import { GetDataSecondBilletRequest } from '~/store/modules/properties/actions';
import { store } from '~/store';

import api from '~/services/apiBearer';

export default function SecondBillet() {
  // #region Attributes
  const property = useSelector(state => state.property.property);

  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [totalPages] = useState(10);
  const [showNextPageButton, setShowNextPageButton] = useState(true);
  const [loader, setLoader] = useState(
    useSelector(state => state.properties.loading)
  );
  const [secondBillet, setSecondBillet] = useState(
    store.getState().properties.data.data
  );
  // #endregion

  // #region Functions
  useEffect(() => {
    const { token } = store.getState().auth;

    if (property.contract > 0)
      dispatch(
        GetDataSecondBilletRequest(token, property.contract, page, totalPages)
      );
  }, [dispatch, page, property.contract, totalPages]);

  useEffect(() => {
    setLoader(true);

    if (!property || !property.contract) return;

    const url = `api/v1/WSBoleto?Contrato=${property.contract}&pagina=${page}&tamanhoPagina=${totalPages}`;
    api
      .get(url)
      .then(
        response => {
          const {
            sucesso: success,
            mensagem: message,
            conteudo,
          } = response.data;

          if (!success) {
            toast.error(
              'Ocorreu um interno, por favor tente novamente mais tarde.'
            );
            console.log(message);
            return;
          }

          setSecondBillet(conteudo);

          if (conteudo.length < 10) {
            setShowNextPageButton(false);
          } else {
            setShowNextPageButton(true);
          }
        },
        error => {
          toast.error(
            'Ocorreu um interno, por favor tente novamente mais tarde.'
          );
          console.error(error);
        }
      )
      .then(() => {
        setLoader(false);
      });
  }, [page, property, totalPages]);

  function handleToCopy() {
    const text = document.querySelector('#barcodeNumber');
    text.select();
    try {
      const ok = document.execCommand('copy');
      if (ok) {
        toast.success('Número de boleto copiado para a área de transferência');
      }
    } catch (e) {
      toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
    }
  }

  function handleBilletGeneration(link) {
    if (!link) {
      toast.error('Ocorreu um erro interno, tente novamente mais tarde.');
      return;
    }
    window.open(link);
  }
  // #endregion

  return (
    <Container>
      <Loader style={{ display: loader ? 'block' : 'none' }} />
      <Info key={property.contract}>
        <h3>Ref.: {property.reference}</h3>
        <h3>Contrato: {property.contract}</h3>
        <h3 className="title">
          <p>2º via de boleto</p> {property.address}
        </h3>
      </Info>
      <Table>
        <thead>
          <tr>
            <td>Vencimento</td>
            <td>Nº do boleto</td>
            <td>Aluguel</td>
            <td>Abatimento</td>
            <td>Taxas</td>
            <td>Situação</td>
            <td>Boleto</td>
          </tr>
        </thead>
        {secondBillet && secondBillet.length ? (
          secondBillet.map(second => {
            const pago = second.status === 'Pago';
            return (
              <Tbody
                key={second.codigoRecibo}
                statusColor={pago ? '#66CC00' : '#CC0000'}
              >
                <tr key={second.codigoRecibo}>
                  <td>
                    {second.vencimento
                      ? format(new Date(second.vencimento), 'dd/MM/yyyy')
                      : second.vencimento}
                  </td>
                  <td>
                    <input
                      id="barcodeNumber"
                      onClick={handleToCopy}
                      defaultValue={
                        second.codigoBarras
                          ? second.codigoBarras
                          : '000 0000 0000 0000 0'
                      }
                    />
                  </td>
                  <td>R$ {second.valorAluguel}</td>
                  <td>R$ {second.valorBonificacao}</td>
                  <td>R$ {second.valorTaxa}</td>
                  <td className="status">{second.status}</td>
                  <td>
                    {second.status === 'Pago' ||
                    second.status === 'Cancelado' ? (
                      ''
                    ) : (
                      <MdPrint
                        size={20}
                        onClick={() => handleBilletGeneration(second.link)}
                      />
                    )}
                  </td>
                </tr>
              </Tbody>
            );
          })
        ) : (
          <div>Você ainda não possui nenhum boleto.</div>
        )}
      </Table>
      {secondBillet && secondBillet.length ? (
        <Pagination>
          <div>
            {page > 1 ? (
              <FaArrowAltCircleLeft
                size={22}
                onClick={() => setPage(page - 1)}
              />
            ) : (
              <FaArrowAltCircleLeft
                size={22}
                color="#bbb"
                style={{ cursor: 'initial' }}
              />
            )}
            {`Visualizando página ${page}`}
            {showNextPageButton ? (
              <FaArrowAltCircleRight
                size={22}
                onClick={() => setPage(page + 1)}
              />
            ) : (
              <FaArrowAltCircleRight
                size={22}
                color="#bbb"
                style={{ cursor: 'initial' }}
              />
            )}
          </div>
        </Pagination>
      ) : (
        ''
      )}
    </Container>
  );
}
